export const returnLabelFont = (theme, size, weight) => {
    return `${weight} ${size}px/${size + 2}px ${
        theme.overrides.MuiTypography.body1.fontFamily
    }`;
};

export const hidden = { visible: false };
export const visible = { visible: true };
